import React from 'react'
import PropTypes from 'prop-types'
import { Highlight, HighlightsMain } from './index.style'
import Container from '@components/Container'
import Grid from '@components/Grid'
import GridItem from '@components/GridItem'
import Spacer from '@components/Spacer'
import { Heading2Serif, Heading4Serif, TextBody } from '@components/TextStyles'
import { GatsbyImage } from 'gatsby-plugin-image'
import AnimateSplitText from '@components/animation/AnimateSplitText'

const Highlights = ({ title, items }) => {
  return (
    <HighlightsMain>
      <Spacer size={[40, 100]} />

      <Container>
        <Grid tiny={6} tabletL={14}>
          <GridItem tabletL={4}>
            <Heading2Serif as="h2">
              <AnimateSplitText offset="1.5em">{title}</AnimateSplitText>
            </Heading2Serif>

            <Spacer size={[40, 80]} />
          </GridItem>

          {React.Children.toArray(
            items.map((highlight, highlightIndex) => (
              <GridItem
                tiny={4}
                tabletL={4}
                tabletLStart={
                  highlightIndex === 0 || highlightIndex === 2
                    ? 6
                    : highlightIndex === 1 || highlightIndex === 3
                    ? 10
                    : undefined
                }
              >
                <Highlight>
                  <GatsbyImage
                    image={highlight.illustration.gatsbyImageData}
                    alt={highlight.illustration.description}
                  />

                  <Spacer size={[20, 40]} />

                  <Heading4Serif as="h3">{highlight.title}</Heading4Serif>

                  <Spacer size={[10, 20]} />

                  <TextBody maxWidth={12.6363636364}>
                    {highlight.description.description}
                  </TextBody>

                  <Spacer size={51} />
                </Highlight>
              </GridItem>
            ))
          )}
        </Grid>
      </Container>

      <Spacer size={[40, 100]} />
    </HighlightsMain>
  )
}

Highlights.propTypes = {
  title: PropTypes.string,
  items: PropTypes.array,
}

export default Highlights
